import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

// export const refreshAccessToken = (API_BASE_URL)=> createAsyncThunk(
//     "auth/refreshAccessToken",
//     async (_, { dispatch }) => {
//         const refreshToken = Cookies.get("refreshToken");
//         if (refreshToken) {
//             const res = await axios.post(`${API_BASE_URL}/auth/refresh`, {
//                 long_lived_token: refreshToken,
//             });
//             const { access_token } = res.data;
//             dispatch(LoginSuccess({ accessToken: access_token }));
//             return access_token;
//         } else {
//             dispatch(LoginFailure());
//             throw new Error("No refresh token");
//         }
//     }
// );
// redux/actions/authActions.js or wherever it's defined

export const refreshAccessToken = (API_BASE_URL) => async (dispatch) => {
  try {
    const refreshToken = Cookies.get("refreshToken");
    if (!refreshToken) return;

    const res = await fetch(`${API_BASE_URL}/auth/refresh`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ long_lived_token: refreshToken }),
    });

    if (!res.ok) throw new Error("Refresh failed");
    const data = await res.json();

    dispatch(LoginSuccess({
      accessToken: data.access_token,
      user_name: localStorage.getItem("user_name"),
    }));

    //fetching updated user data on page load calling /me
    const meRes = await fetch(`${API_BASE_URL}/me`, {
        method:'POST',
        headers: {
          "Authorization": `Bearer ${data.access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (meRes.ok) {
        const userData = await meRes.json();
        localStorage.setItem("userData", JSON.stringify(userData));
        dispatch(SetUserData(userData));
      }
  } catch (err) {
    console.error("Token refresh or /me failed:", err);
    dispatch(LoginFailure());
  }
};


const initialState = {
    user_name: localStorage.getItem("user_name") || null,
    accessToken: null,
    isAuthenticated: false,
    userData: JSON.parse(localStorage.getItem("userData")) || null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        LoginSuccess: (state, action) => {
            state.user_name = action.payload.user_name;
            state.accessToken = action.payload.accessToken;
            state.isAuthenticated = true;
        },
        LoginFailure: (state) => {
            state.user_name = null;
            state.accessToken = null;
            state.isAuthenticated = false;
            Cookies.remove('refreshToken'); // remove refresh token
            localStorage.clear(); // clear all auth tokens
        },
        SetUserData: (state, action) => {
            state.userData = action.payload;
        },
    },
});

export const { LoginSuccess, LoginFailure, SetUserData } = authSlice.actions;
export default authSlice.reducer;
